import {
  GET_STATS,
  GET_STATS_SUCCESS,
  GET_STATS_NEXT_PAGE_SUCCESS,
  GET_STATS_ERROR,
  GET_LIVE_ATTENDEES,
  GET_LIVE_ATTENDEES_SUCCESS,
  GET_LIVE_ATTENDEES_ERROR,
  GET_RECORDED_VIEWS,
  GET_RECORDED_VIEWS_SUCCESS,
  GET_RECORDED_VIEWS_ERROR,
  GET_WEBINAR_DATA,
  GET_WEBINAR_DATA_SUCCESS,
  GET_WEBINAR_DATA_ERROR,
} from "../constants/actions";

const INITIAL_STATE = {
  workshop: null,
  webinar_id: 0,
  webinar: null,
  users: [],
  stats: [],
  statistic_type: "",
  meta: {
    page: 1,
    per_page: 10,
    pages: 1,
  },
  dataVisualisation: {},
  filter: "",
  error: null,
};

const stats = (state = INITIAL_STATE, action) => {
  const { type, payload } = action || {};
  const {
    workshop,
    webinar_id,
    webinar,
    stats,
    pages,
    meta,
    users,
    dataVisualisation,
    filter,
    error,
  } = payload || {};

  switch (type) {
    case GET_STATS:
      return {
        ...state,
        meta,
      };
    case GET_STATS_SUCCESS:
      return {
        ...state,
        stats,
        meta: {
          ...state.meta,
          pages,
        },
      };
    case GET_STATS_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        stats: [...state.stats, ...stats],
      };
    case GET_LIVE_ATTENDEES:
    case GET_RECORDED_VIEWS:
      return {
        ...state,
        workshop,
      };
    case GET_LIVE_ATTENDEES_SUCCESS:
      return {
        ...state,
        users,
        statistic_type: "attended",
      };
    case GET_RECORDED_VIEWS_SUCCESS:
      return {
        ...state,
        users,
        statistic_type: "viewed",
      };
    case GET_WEBINAR_DATA:
      return {
        ...state,
        webinar: {
          id: webinar_id,
        },
      };
    case GET_WEBINAR_DATA_SUCCESS:
      return {
        ...state,
        webinar,
      };
    case GET_WEBINAR_DATA_ERROR:
    case GET_LIVE_ATTENDEES_ERROR:
    case GET_RECORDED_VIEWS_ERROR:
    case GET_STATS_ERROR:
    default:
      return state;
  }
};

export { stats };



// WEBPACK FOOTER //
// ./src/reducers/stats.js